export const DASH = "—";

export const formatHours = (n: number) =>
  n.toLocaleString("en-US", { maximumFractionDigits: 2 });

export const formatMoney = (n: number, currency: string, signed = false) => {
  const abs = Math.abs(n).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const sign = n < 0 ? "-" : signed ? "+" : "";
  return `${sign}${currency}${abs}`;
};
